import { useTranslate } from '@festina-life/ui/hooks'

import type { TemplateVersion } from '../../../types/templateModel'
import { BlockIndicator } from '../../blockIndicator/BlockIndicator'
import { LayerIndicator } from '../../layerIndicator/LayerIndicator'

type Props = {
  templateVersion: TemplateVersion
}

export const TemplateVersionTitle = ({ templateVersion }: Props) => {
  const translate = useTranslate()

  return (
    <div className="flex flex-col gap-y-2 font-normal">
      <div className="grid grid-cols-[auto_max-content] gap-x-4">
        <span className="truncate font-thin">
          {templateVersion.versionInfo.identifier}
        </span>
        <span className="font-medium">{templateVersion.typeName}</span>
      </div>
      <div className="grid grid-cols-2 items-center">
        <div className="text-lg italic text-gray-400 ">
          {translate('templateViewer.templateVersionDetails.templateRole')}
        </div>
        <div className="flex flex-row items-center justify-end gap-x-2">
          <BlockIndicator
            block={templateVersion.block}
            shouldShowIcon={false}
            isSecondaryBackground={false}
          />
          <LayerIndicator
            layer={templateVersion.layer}
            isSecondaryBackground={false}
          />
        </div>
      </div>
    </div>
  )
}
